import "core-js/stable/index.js";
import "regenerator-runtime/runtime.js";
import Sidebar from "../../components/sidebar/Sidebar.js";
import React from "react";
import ReactDOM from "react-dom";
import {Integration, Highlighter, Session} from "@digintent/pn-highlight-lib/integrations";
import Reporter from "./reporter/index.ts";

if (typeof PowerNotes === "undefined")
	window.PowerNotes = {};

export async function init(opts) {
	const container = document.querySelector(opts.container);
	if (!container) {
		console.warn("PN: Could not find container");
		return;
	}

	console.log(`PN: Initializing "${opts.integration}" integration...`, {container});
	Integration.init(opts.integration, opts.getClientToken, Reporter.gtag);

	// Session. This must be the first thing we do here because if it fails,
	// it could mean that the extension is present, in which case we do nothing.
	try {
		await Session.initIntegration();
	} catch (e) {
		console.warn("PN: Stopping due to error in Session.initIntegration", e);
		return;
	}

	// Highlighter
	await Highlighter.initIntegration();

	// Sidebar
	const wrapper = document.createElement("div");
	container.appendChild(wrapper);
	ReactDOM.render((
		<Sidebar
			sessionCodes={opts.sessionCodes ?? false}
			floating={opts.floating ?? true}
			alwaysVisible={opts.alwaysVisible ?? false}
			projectSelector={opts.projectSelector ?? true}
			accountMenu={opts.accountMenu ?? true}
		/>
	), wrapper);

	// Reporter iframe (used to send events to GA)
	container.appendChild(Reporter.getFrame(opts.integration));

	// TODO: replace PDF links (use `opts.pdfLinks`)

	if (!customElements.get("emoji-picker")) {
		// Add emoji picker custom element definition to the page
		const emojiScript = document.createElement("script");
		emojiScript.src = "https://cdn.jsdelivr.net/npm/emoji-picker-element@^1/index.js";
		emojiScript.type = "module";
		document.head.append(emojiScript);
	} else
		console.warn("emoji-picker is already defined");
}
